/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ApiKeyResponse,
    ApiKeyResponseFromJSON,
    ApiKeyResponseToJSON,
} from '../models/ApiKeyResponse';
import {
    type UserProfileData,
    UserProfileDataFromJSON,
    UserProfileDataToJSON,
} from '../models/UserProfileData';

/**
 * 
 */
export class MyProfileApi extends runtime.BaseAPI {

    /**
     * Creates request options for generateApiKey without sending the request
     */
    async generateApiKeyRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me/apikey`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async generateApiKeyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiKeyResponse>> {
        const requestOptions = await this.generateApiKeyRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiKeyResponseFromJSON(jsonValue));
    }

    /**
     */
    async generateApiKey(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiKeyResponse> {
        const response = await this.generateApiKeyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMyProfile without sending the request
     */
    async getMyProfileRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/me/profile`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get my profile
     */
    async getMyProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserProfileData>> {
        const requestOptions = await this.getMyProfileRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserProfileDataFromJSON(jsonValue));
    }

    /**
     * Get my profile
     */
    async getMyProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserProfileData> {
        const response = await this.getMyProfileRaw(initOverrides);
        return await response.value();
    }

}
